module.exports = __webpack_public_path__ + "static/img/2.8d64b26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/2.png
// module id = unpC
// module chunks = 0